"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const recoil_1 = require("recoil");
const openedDialogListStateForAABB_1 = __importDefault(require("./openedDialogListStateForAABB"));
const react_device_detect_1 = require("react-device-detect");
const _1 = require(".");
/**
 * @desc 안드로이드 앱 + 안드로이드 기기 뒤로가기 버튼 -> 다이얼로그 닫기
 * @param dialogName 2개 이상의 Dialog가 중첩될 때, 닫힐 Dialog를 구분하기 위해 사용
 * @AABB Android App Back Button
 */
function default_1({ open, closeDialog = () => { }, additionalDeps = [], dialogName, isPageUnloadable, }) {
    const [openedDialogList, setOpenedDialogList] = (0, recoil_1.useRecoilState)(openedDialogListStateForAABB_1.default);
    const resetOpenedDialogList = (0, recoil_1.useResetRecoilState)(openedDialogListStateForAABB_1.default);
    const isOpenedDialog = !dialogName ? true : openedDialogList.includes(dialogName);
    const isCurrentDialog = dialogName === openedDialogList[0];
    const resetDialogState = () => {
        (0, _1.postMessageToWVA)('DIALOGCLOSED');
        resetOpenedDialogList();
    };
    (0, react_1.useEffect)(() => {
        if (window.isNativeApp && react_device_detect_1.isAndroid && open) {
            (0, _1.postMessageToWVA)('DIALOGOPEN');
            if (dialogName)
                setOpenedDialogList(prev => [dialogName, ...prev]);
            if (isPageUnloadable)
                window.addEventListener('beforeunload', resetDialogState);
            return () => {
                setOpenedDialogList(prev => {
                    if (prev.length < 2)
                        (0, _1.postMessageToWVA)('DIALOGCLOSED');
                    return prev.filter(openedDialog => openedDialog !== dialogName);
                });
                if (isPageUnloadable)
                    window.removeEventListener('beforeunload', resetDialogState);
            };
        }
    }, [open]);
    (0, react_1.useEffect)(() => {
        if (window.isNativeApp && react_device_detect_1.isAndroid && open && isOpenedDialog) {
            const closeDialogOnABBPressed = (message) => {
                if (message.data === 'CLOSEDIALOG') {
                    if (dialogName)
                        isCurrentDialog && closeDialog();
                    else
                        closeDialog();
                }
            };
            window.addEventListener('message', closeDialogOnABBPressed);
            return () => {
                window.removeEventListener('message', closeDialogOnABBPressed);
            };
        }
    }, [open, openedDialogList, ...additionalDeps]);
}
exports.default = default_1;
